import Language from '../Language'

export default new Language(
  'Danish',
  ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
  ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø']
)

  ;
